import React, { PureComponent } from 'react'
import AwsConfig from '../../../Config/AwsConfig'
import {
  heightPercentageToDP as heightPercentage,
  widthPercentageToDP as widthPercentage,
} from '../../../Utils/ResponsiveScreen'
import { KTColors } from '../../Constants/KTColors'
import { fonts } from '../../Constants/theme'

const styles = {
  container: {
    flex: 1,
    width: '100%',
  },
  cardContainer: {
    flex: 1,
    justifyContent: 'center',
  },
  card: {
    width: widthPercentage('100'),
    height: heightPercentage('100'),
    shadowColor: 'rgba(0,0,0,0.5)',
    shadowOffset: {
      width: 0,
      height: 1,
    },
    justifyContent: 'center',
    alignItems: 'center',
    shadowOpacity: 0.5,
    padding: widthPercentage('5%'),
  },

  questionText: {
    textAlign: 'center',
    fontFamily: fonts.fontFamilyPoppinsLight,
    fontSize: heightPercentage('2.8%'),
    lineHeight: heightPercentage('3.6%'),
    fontWeight: 'bold',
    marginBottom: heightPercentage('1%'),
  },
  buttonText: {
    fontSize: heightPercentage('2.4%'),
    lineHeight: heightPercentage('2.6%'),
    fontFamily: fonts.fontFamilyPoppinsLight,
  },
  button: {
    borderWidth: 0.8,
    opacity: 0.8,
    width: widthPercentage('90%'),
    marginTop: heightPercentage('1.5%'),
  },

  questionsContentPoster: {
    height: heightPercentage('100'),
    resizeMode: 'cover',
  },
  questionContainerBorder: {
    backgroundColor: 'rgba(0, 0, 0, 0.36)',
    padding: widthPercentage('2.5%'),
    borderRadius: 10,
  },
  titleBgColorStyle: {
    width: widthPercentage('90%'),
    justifyContent: 'center',
    alignItems: 'center',
    left: widthPercentage('5%'),
    position: 'absolute',
    backgroundColor: 'rgba(0, 0, 0, 0.36)',
    padding: widthPercentage('2.5%'),
    borderRadius: 10,
    borderWidth: 2,
  },
  titleNoBgColor: {
    width: widthPercentage('90%'),
    justifyContent: 'center',
    alignItems: 'center',
    left: widthPercentage('5%'),
    position: 'absolute',
    padding: widthPercentage('2.5%'),
  },
}

class InAppBrowserView extends PureComponent {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    // const { link } = this.props.content.contentMetaInfo.coverStoryDetails.inAppBrowserDetails
    // try {
    //   InAppBrowser.preInitialize(link)
    // } catch (error) {
    //   console.warn('in app link error', error)
    // }
  }

  render() {
    const { content, coverStoryTitle } = this.props
    const {
      coverStoryImages,
      coverStoryOriginalImages,
      contentTitlePosition,
      textColor,
      backGroundTitle,
      link,
      linkText,
    } = content.contentMetaInfo.coverStoryDetails.inAppBrowserDetails
    // const coverStoryImage = coverStoryImages
    //   ? this.props.preview
    //     ? coverStoryImages[0].path
    //     : coverStoryImages[0].image
    //   : null
    const topPosition = contentTitlePosition ? contentTitlePosition : 50
    const titleColor = textColor ? textColor : KTColors.white
    const titleBgColor = backGroundTitle ? backGroundTitle : false
    // const coverStoryBgImg = 'dist/img/photo2.png'

    const coverStoryBgImg =
      coverStoryOriginalImages && coverStoryOriginalImages[0]
        ? coverStoryOriginalImages[0].imageValue
        : coverStoryImages && coverStoryImages[0]
          ? coverStoryImages[0].image
          : ''
    let cdnurl = AwsConfig.cdn_url
    const imageWithcdn = coverStoryBgImg ? coverStoryBgImg.includes(cdnurl) ? coverStoryBgImg : cdnurl + coverStoryBgImg : ''

    return (
      <div style={{ flex: 1, height: heightPercentage('100%') }}>
        <div>
          <div
            style={{
              height: heightPercentage('100%'),
              backgroundImage: `url(${imageWithcdn})`,
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
            }}
          >
            <div
              style={
                titleBgColor
                  ? {
                    ...styles.titleBgColorStyle,
                    ...{ top: heightPercentage(`${topPosition}%`) },
                  }
                  : { ...styles.titleNoBgColor, ...{ top: heightPercentage(`${topPosition}%`) } }
              }
            >
              <div style={styles.questionTextContainer}>
                <p
                  style={{
                    fontSize: heightPercentage('2.2%'),
                    color: titleColor,
                    fontFamily: fonts.fontFamilyPoppinsLight,
                    textAlign: 'center',
                  }}
                >
                  {coverStoryTitle}
                </p>
              </div>
              <div>
                {linkText ? (
                  <div
                    style={{
                      textAlign: 'center',
                    }}
                  >
                    <button
                      style={{
                        textAlign: 'center',
                        backgroundColor: 'transparent',
                        color: titleColor,
                        paddingLeft: widthPercentage('3%'),
                        paddingRight: widthPercentage('3%'),
                        opacity: 0.8,
                        borderStyle: 'solid',
                        borderColor: titleColor,
                        borderRadius: 5,
                      }}
                    //onClick={() => window.open(link)}
                    >
                      {linkText}
                    </button>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default InAppBrowserView
